// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"3b4c4cb4","779":"3b4c4cb4"}[chunkId] + ".chunk.css";
};